import type { Components, Theme } from '@mui/material/styles';

export const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: ({ theme: { typography } }) => ({
      fontSize: typography.body2.fontSize,
    }),
  },
};
